import { useAppSelector } from "store/store";

export const usePreview = () => {
    const images = useAppSelector((store) => store.bulkResize.images);
    return { images };
};
